export default __webpack_public_path__ + "static/GRID22-25-countries-fr-589b0c5cb4ed6cd9a8f9889859a37a62.png";